export default (fn) => (event) => {
  event.stopPropagation();
  return fn(event);
};
